import { Location } from '@fcom/core-api/interfaces';

export interface FlightSearchEventPayload {
  locale: string;
  sessionId?: string;
  requestId?: string;
  multivariateTest?: {
    testId?: string;
    segment: number;
    source: string;
    variant: string;
  };
  data: {
    label: EventLabel;
    departureAirport?: string;
    arrivalAirport?: string;
    departureCity?: string;
    arrivalCity?: string;
    departureDate: string;
    returnDate?: string;
    passengers?: {
      main?: number;
      children?: number;
    };
  };
}

export enum EventLabel {
  SEARCH_CONNECTIONS = 'SearchConnections',
}

export interface TrendingDestinationsResponse<T> {
  locations: T[];
}

export interface TrendingDestinationsBaseLocation {
  locationCode: string;
  trend: number;
  score: number;
}

interface DestinationLocationExtension {
  isIncludedInCampaign: boolean;
  enableBlackTeaser: boolean;
  badgeLabel: string;
  destinationUrl: string;
}

export type TrendingDestinationLocation = Location & TrendingDestinationsBaseLocation & DestinationLocationExtension;

export type PersonalizedDestinationLocation = Location & DestinationLocationExtension;
